<template>
  <div class="header">
    <div class="app-header">
      <div class="header">
        <div class="header-body">
          <div class="nav-bar">
            <div class="nav-bar-logo">
              <a href="/"><img src="../assets/logo1.png"/></a>
            </div>
            <!-- <ul class="nav-bar-list">
              <li><el-link href='javascript:;'>题库</el-link></li>
            </ul> -->
          </div>
          <div class="header-info">
            <!-- <div class="header-search">
              <input type="text" placeholder="搜索课程代码/名称" />
              <div class="search-icon">
                <i class="el-icon-search"></i>
              </div>
            </div> -->
            <el-link href="/" class="uname">个人中心</el-link>
            <div class="header-message">
              <span class="header-message-icon">
                <i class="el-icon-bell"></i>
                <i class="noread" v-show="notifyNum > 0">{{notifyNum}}</i>
              </span>
              <div class="header-message-box">
                <div class="header-message-drop">
                  <div class="header-message-title">消息盒</div>
                  <ul
                    class="header-message-body"
                    v-if="messageList.length > 0"
                  >
                    <li class="message-list"
                      v-for="(item, index) in messageList"
                      :key="index"
                    >
                    <router-link :to="{ name: 'Message' }">
                      <div>{{ item.title }}</div>
                      <p>{{ item.create_time }}</p>
                    </router-link>
                    </li>
                  </ul>
                  <div
                    v-else
                    class="header-message-body"
                    style="text-align: center; padding: 15px 0"
                  >
                    暂无未读消息
                  </div>
                  <!-- <div class="header-message-body" style="text-align: center; padding: 15px 0px;"> 暂无未读消息 </div> -->
                  <!-- <a class="header-message-footer" href="javascript:;" @click="toMessage()">查看全部</a> -->
                  <router-link :to="{ name: 'Message' }">
                    <a
                      href="javascript:;"
                      class="header-message-footer"
                    >查看全部</a>
                  </router-link>
                </div>
              </div>
            </div>
            <a class="header-link" href="javascript:;" @click="logout()">退出</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { GetMemberNoticeList } from "../api/api";
export default {
  name: 'Header',
  data () {
    return {
      uname: '',
      messageList: [],
      notifyNum: 0
    }
  },
  created() {
    var uname = window.localStorage.getItem('uname')
    this.uname = uname

  },
  mounted () {
    this.getMessageList();
  },
  methods: {
    toMessage () {

    },

    getMessageList () {
      GetMemberNoticeList().then((res) => {
        if (res.code === 1) {
          // var list = res.data.list
          this.notifyNum = res.data.noread
          var messageList = []
          // list.forEach((item) => {
          //   if(item.isread == 0){
          //     messageList.push(item)
          //   }
          // })
          this.messageList = res.data.list.slice(0, 6);
        }
      });
    },

    logout() {
      this.$store.dispatch("refreshToken", {});
      this.$router.push('/login')
      // this.$router.go(0);
    }
  }
}
</script>

<style>
.uname{color: #fff !important; font-size: 16px;}
.el-link.el-link--default:hover{border-bottom: 1px solid #fff !important;}
.el-link.is-underline:hover:after{}
.app-header {
	width: 100%
}

.app-header .header {
	width: 100%;
	height: 70px;
	padding: 10px 0;
	background: rgba(0, 0, 0, 0.6);
	position: fixed;
	top: 0;
	left: 0;
	z-index: 999
}

.app-header .header-body {
	position: relative;
	width: 1200px;
	margin: 0 auto;
	display: flex
}

.app-header .header-body .nav-bar {
	flex: 1
}

.app-header .header-body .nav-bar .nav-bar-logo {
	height: 50px;
	min-width: 180px;
	max-width: 250px;
	overflow: hidden;
	margin: 0 20px 0 0;
	display: inline-block;
	vertical-align: middle
}

.app-header .header-body .nav-bar .nav-bar-logo img {
	height: 50px;
	display: block
}

.app-header .header-body .nav-bar .nav-bar-list {
	display: inline-block;
	vertical-align: middle;
  margin:0;
  padding:0;
}

.app-header .header-body .nav-bar .nav-bar-list li {
	display: inline-block;
	margin: -10px 15px;
	vertical-align: top;
	height: 70px
}

.app-header .header-body .nav-bar .nav-bar-list li>a {
	position: relative;
	width: 70px;
	height: 100%;
	line-height: 70px;
	display: block;
	color: #aaa;
	font-size: 16px;
	text-align: center;
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden
}

.app-header .header-body .nav-bar .nav-bar-list li>a:hover {
	color: #227efa;
	font-weight: 700
}

.app-header .header-body .nav-bar .nav-bar-list li>a:hover:before {
	position: absolute;
	content: " ";
	border-bottom: 2px solid #227efa;
	bottom: 15px;
	left: 0;
	width: 100%
}

.app-header .header-body .nav-bar .nav-bar-list li>a.selected {
	color: #fff;
	font-weight: 700
}

.app-header .header-body .nav-bar .nav-bar-list li>a.selected:before {
	position: absolute;
	content: " ";
	border-bottom: 2px solid #fff;
	bottom: 15px;
	left: 0;
	width: 100%
}

.app-header .header-body .nav-bar .nav-bar-more {
	position: relative;
	display: inline-block;
	vertical-align: middle;
	width: 30px;
	height: 70px;
	line-height: 70px;
	text-align: center;
	margin: -10px 10px
}

.app-header .header-body .nav-bar .nav-bar-more:hover.selected,
.app-header .header-body .nav-bar .nav-bar-more:hover:before {
	position: absolute;
	content: " ";
	border: 8px solid transparent;
	border-bottom: 8px solid #fff;
	bottom: 0;
	left: 7px
}

.app-header .header-body .nav-bar .nav-bar-more:hover .more-icon {
	color: #fff;
	font-size: 30px
}

.app-header .header-body .nav-bar .nav-bar-more:hover .more-box {
	visibility: visible
}

.app-header .header-body .nav-bar .nav-bar-more:hover .more-box .more-drop {
	visibility: visible;
	transform: translateY(0)
}

.app-header .header-body .nav-bar .nav-bar-more .more-icon {
	display: block;
	color: #aaa;
	font-size: 26px
}

.app-header .header-body .nav-bar .nav-bar-more .more-icon i {
	vertical-align: -.16em
}

.app-header .header-body .nav-bar .nav-bar-more .more-box {
	position: absolute;
	top: 70px;
	left: -48px;
	width: 130px;
	height: auto;
	padding: 0 5px 5px 5px;
	overflow: hidden;
	visibility: hidden
}

.app-header .header-body .nav-bar .nav-bar-more .more-box .more-drop {
	visibility: hidden;
	width: 120px;
	background: #fff;
	box-shadow: 0 0 5px rgba(0, 0, 0, .2);
	color: #333;
	text-align: left;
	border-bottom-left-radius: 4px;
	border-bottom-right-radius: 4px;
	background-color: #fff;
	z-index: 40;
	transform: translateY(-100%);
	transition: transform .2s linear;
	padding: 10px 0
}

.app-header .header-body .nav-bar .nav-bar-more .more-box .more-drop li a {
	display: block;
	height: 36px;
	line-height: 36px;
	padding: 0 20px;
	color: #666;
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden
}

.app-header .header-body .nav-bar .nav-bar-more .more-box .more-drop li a:hover {
	background-color: #41a5fd;
	color: #fff
}

.app-header .header-body .header-info {
	position: relative;
	width: 350px;
	text-align: right
}

.app-header .header-body .header-info .header-search {
	height: 30px;
	margin: 10px 0;
	overflow: hidden;
	border: 1px solid #aaa;
	background: hsla(0, 0%, 100%, .3);
	border-radius: 50px;
	padding: 4px 10px 4px 15px;
	display: inline-block;
	vertical-align: middle
}

.app-header .header-body .header-info .header-search:hover {
	border-color: #fff
}

.app-header .header-body .header-info .header-search:hover .search-icon {
	color: #fff
}

.app-header .header-body .header-info .header-search input[type=text] {
	width: 130px;
	height: 20px;
	border: none;
	outline: none;
	background-color: transparent;
	color: #fff;
	margin: 0;
	padding: 0
}

.app-header .header-body .header-info .header-search input[type=text]::-moz-placeholder {
	color: #ccc
}

.app-header .header-body .header-info .header-search input[type=text]:-ms-input-placeholder {
	color: #ccc
}

.app-header .header-body .header-info .header-search input[type=text]::placeholder {
	color: #ccc
}

.app-header .header-body .header-info .header-search .search-icon {
	display: inline-block;
	vertical-align: middle;
	width: 20px;
	height: 20px;
	cursor: pointer;
	color: #aaa
}

.app-header .header-body .header-info .header-search .search-icon i {
	margin-top: -3px
}

.app-header .header-body .header-info .header-message {
	position: relative;
	margin: -10px 10px;
	height: 70px;
	display: inline-block;
	vertical-align: middle
}

.app-header .header-body .header-info .header-message .header-message-icon {
	display: inline-block;
	padding: 10px 10px;
	width: 50px;
	height: 50px;
	line-height: 48px;
	text-align: center;
	transition: transform .2s linear;
	color: #aaa;
	font-size: 24px;
  position: relative;
}
.app-header .header-body .header-info .header-message .header-message-icon .noread {
	position: absolute;
  top: 14px;
  right:6px;
  background: red;
  width: 20px;
  height: 20px;
  color: #fff;
  font-style: normal;
  line-height: 20px;
  font-size: 18px;
  border-radius: 100%;
}

.app-header .header-body .header-info .header-message .header-message-box {
	position: absolute;
	top: 70px;
	right: 0;
	width: 310px;
	padding: 0 5px 5px 5px;
	height: auto;
	overflow: hidden;
	visibility: hidden
}

.app-header .header-body .header-info .header-message .header-message-drop {
	visibility: hidden;
	width: 300px;
	background: #fff;
	border-top: none;
	box-shadow: 0 0 5px rgba(0, 0, 0, .2);
	color: #333;
	text-align: left;
	border-bottom-left-radius: 4px;
	border-bottom-right-radius: 4px;
	background-color: #fff;
	z-index: 30;
	transform: translateY(-100%);
	transition: transform .2s linear
}

.app-header .header-body .header-info .header-message .header-message-drop .header-message-title {
	height: 50px;
	line-height: 50px;
	font-size: 1.6rem;
	padding: 0 20px;
	border-bottom: 1px solid #ddd
}

.app-header .header-body .header-info .header-message .header-message-drop .header-message-body {
	padding: 5px 0
}

.app-header .header-body .header-info .header-message .header-message-drop .header-message-body li a {
	display: block;
	padding: 8px 20px;
	color: #222;
	line-height: 22px;
	overflow: hidden
}

.app-header .header-body .header-info .header-message .header-message-drop .header-message-body li a:hover {
	background-color: #41a5fd;
	color: #fff
}

.header-message .message-list{
  border-bottom: 1px solid #f2f2f2;
}
.header-message .message-list p{
  text-align: right;
  font-size: 13px;
  color: #666;
}

.app-header .header-body .header-info .header-message .header-message-drop .header-message-footer {
	display: block;
	font-size: 16px;
	padding: 10px 20px;
	text-align: center;
	border-top: 1px solid #ddd;
	color: #333
}

.app-header .header-body .header-info .header-message:hover:before {
	position: absolute;
	content: " ";
	border: 8px solid transparent;
	border-bottom: 8px solid #fff;
	bottom: 0;
	left: 16px
}

.app-header .header-body .header-info .header-message:hover .header-message-icon {
	color: #fff;
	font-size: 28px
}

.app-header .header-body .header-info .header-message:hover .header-message-box {
	visibility: visible
}

.app-header .header-body .header-info .header-message:hover .header-message-drop {
	visibility: visible;
	transform: translateY(0)
}

.app-header .header-body .header-info .header-link {
	width: 92px;
	height: 30px;
	line-height: 30px;
	display: inline-block;
	vertical-align: middle;
	border-radius: 50px;
	text-align: center;
	color: #fff;
  border: 1px solid #fff;
	transition: transform .2s ease
}

.app-header .header-body .header-info .header-link:hover {
	transform: scale(1.05)
}

.app-header .header-body .header-info .header-link-out {
	position: absolute;
	top: 10px;
	right: -100px;
	width: 92px;
	height: 30px;
	line-height: 28px;
	display: inline-block;
	vertical-align: middle;
	border-radius: 50px;
	text-align: center;
	border: 1px solid #fff;
	background: transparent;
	transition: transform .2s ease;
	color: #fff
}

.app-header .header-body .header-info .header-link-out:hover {
	transform: scale(1.05)
}


/* .app-header {
	width: 100%
} */
/*
.app-header .header {
	width: 100%;
	height: 70px;
	padding: 10px 0;
	background: #fff;
	position: fixed;
	top: 0;
	left: 0;
	z-index: 999
} */

/* .app-header .header-body {
	position: relative;
	width: 1200px;
	margin: 0 auto;
	display: flex
}

.app-header .header-body .nav-bar {
	flex: 1
}

.app-header .header-body .nav-bar .nav-bar-logo {
	height: 50px;
	min-width: 180px;
	max-width: 250px;
	overflow: hidden;
	margin: 0 20px 0 0;
	display: inline-block;
	vertical-align: middle
}

.app-header .header-body .nav-bar .nav-bar-logo img {
	height: 50px;
	display: block
}

.app-header .header-body .nav-bar .nav-bar-list {
	display: inline-block;
	vertical-align: middle
}

.app-header .header-body .nav-bar .nav-bar-list li {
	display: inline-block;
	margin: -10px 15px;
	vertical-align: top;
	height: 70px
}

.app-header .header-body .nav-bar .nav-bar-list li>a {
	position: relative;
	width: 70px;
	height: 100%;
	line-height: 70px;
	display: block;
	color: #666;
	font-size: 16px;
	text-align: center;
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden
}

.app-header .header-body .nav-bar .nav-bar-list li>a:hover {
	color: #227efa;
	font-weight: 700
}

.app-header .header-body .nav-bar .nav-bar-list li>a:hover:before {
	position: absolute;
	content: " ";
	border-bottom: 2px solid #227efa;
	bottom: 15px;
	left: 0;
	width: 100%
}

.app-header .header-body .nav-bar .nav-bar-list li>a.selected {
	color: #333;
	font-weight: 700
}

.app-header .header-body .nav-bar .nav-bar-list li>a.selected:before {
	position: absolute;
	content: " ";
	border-bottom: 2px solid #333;
	bottom: 15px;
	left: 0;
	width: 100%
}

.app-header .header-body .nav-bar .nav-bar-more {
	position: relative;
	display: inline-block;
	vertical-align: middle;
	width: 30px;
	height: 70px;
	line-height: 70px;
	text-align: center;
	margin: -10px 10px
}

.app-header .header-body .nav-bar .nav-bar-more:hover.selected,
.app-header .header-body .nav-bar .nav-bar-more:hover:before {
	position: absolute;
	content: " ";
	border: 8px solid transparent;
	border-bottom: 8px solid #fff;
	bottom: 0;
	left: 7px
}

.app-header .header-body .nav-bar .nav-bar-more:hover .more-icon {
	color: #333;
	font-size: 30px
}

.app-header .header-body .nav-bar .nav-bar-more:hover .more-box {
	visibility: visible
}

.app-header .header-body .nav-bar .nav-bar-more:hover .more-box .more-drop {
	visibility: visible;
	transform: translateY(0)
}

.app-header .header-body .nav-bar .nav-bar-more .more-icon {
	display: block;
	color: #666;
	font-size: 26px
}

.app-header .header-body .nav-bar .nav-bar-more .more-icon i {
	vertical-align: -.16em
}

.app-header .header-body .nav-bar .nav-bar-more .more-box {
	position: absolute;
	top: 70px;
	left: -48px;
	width: 130px;
	height: auto;
	padding: 0 5px 5px 5px;
	overflow: hidden;
	visibility: hidden
}

.app-header .header-body .nav-bar .nav-bar-more .more-box .more-drop {
	visibility: hidden;
	width: 120px;
	box-shadow: 0 0 5px rgba(0, 0, 0, .2);
	color: #333;
	text-align: left;
	border-bottom-left-radius: 4px;
	border-bottom-right-radius: 4px;
	background-color: #fff;
	z-index: 40;
	transform: translateY(-100%);
	transition: transform .2s linear;
	padding: 10px 0
}

.app-header .header-body .nav-bar .nav-bar-more .more-box .more-drop li a {
	display: block;
	height: 36px;
	line-height: 36px;
	padding: 0 20px;
	color: #666;
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden
}

.app-header .header-body .nav-bar .nav-bar-more .more-box .more-drop li a:hover {
	background-color: #41a5fd;
	color: #fff
}

.app-header .header-body .header-info {
	position: relative;
	width: 350px;
	text-align: right
}

.app-header .header-body .header-info .header-search {
	height: 30px;
	margin: 10px 0;
	overflow: hidden;
	border: 1px solid #aaa;
	background: hsla(0, 0%, 100%, .3);
	border-radius: 50px;
	padding: 4px 10px 4px 15px;
	display: inline-block;
	vertical-align: middle
}

.app-header .header-body .header-info .header-search:hover {
	border-color: #333
}

.app-header .header-body .header-info .header-search:hover .search-icon {
	color: #333
}

.app-header .header-body .header-info .header-search input[type=text] {
	width: 130px;
	height: 20px;
	border: none;
	outline: none;
	background-color: transparent;
	color: #333;
	margin: 0;
	padding: 0
}

.app-header .header-body .header-info .header-search input[type=text]::-moz-placeholder {
	color: #999
}

.app-header .header-body .header-info .header-search input[type=text]:-ms-input-placeholder {
	color: #999
}

.app-header .header-body .header-info .header-search input[type=text]::placeholder {
	color: #999
}

.app-header .header-body .header-info .header-search .search-icon {
	display: inline-block;
	vertical-align: middle;
	width: 20px;
	height: 20px;
	cursor: pointer;
	color: #aaa
}

.app-header .header-body .header-info .header-search .search-icon i {
	margin-top: -3px
}

.app-header .header-body .header-info .header-message {
	position: relative;
	margin: -10px 10px;
	height: 70px;
	display: inline-block;
	vertical-align: middle
}

.app-header .header-body .header-info .header-message .header-message-icon {
	display: inline-block;
	padding: 10px 10px;
	width: 50px;
	height: 50px;
	line-height: 48px;
	text-align: center;
	transition: transform .2s linear;
	color: #666;
	font-size: 24px
}

.app-header .header-body .header-info .header-message .header-message-box {
	position: absolute;
	top: 70px;
	right: 0;
	width: 310px;
	padding: 0 5px 5px 5px;
	height: auto;
	overflow: hidden;
	visibility: hidden
}

.app-header .header-body .header-info .header-message .header-message-drop {
	visibility: hidden;
	width: 300px;
	border-top: none;
	box-shadow: 0 0 5px rgba(0, 0, 0, .2);
	color: #333;
	text-align: left;
	border-bottom-left-radius: 4px;
	border-bottom-right-radius: 4px;
	background-color: #fff;
	z-index: 30;
	transform: translateY(-100%);
	transition: transform .2s linear
}

.app-header .header-body .header-info .header-message .header-message-drop .header-message-title {
	height: 50px;
	line-height: 50px;
	font-size: 1.6rem;
	padding: 0 20px;
	border-bottom: 1px solid #ddd
}

.app-header .header-body .header-info .header-message .header-message-drop .header-message-body {
	padding: 5px 0
}

.app-header .header-body .header-info .header-message .header-message-drop .header-message-body li a {
	display: block;
	padding: 8px 20px;
	color: #666;
	line-height: 22px;
	overflow: hidden
}

.app-header .header-body .header-info .header-message .header-message-drop .header-message-body li a:hover {
	background-color: #41a5fd;
	color: #fff
}

.app-header .header-body .header-info .header-message .header-message-drop .header-message-footer {
	display: block;
	font-size: 16px;
	padding: 10px 20px;
	text-align: center;
	border-top: 1px solid #ddd;
	color: #333
}

.app-header .header-body .header-info .header-message:hover:before {
	position: absolute;
	content: " ";
	border: 8px solid transparent;
	border-bottom: 8px solid #fff;
	bottom: 0;
	left: 16px
}

.app-header .header-body .header-info .header-message:hover .header-message-icon {
	color: #333;
	font-size: 28px
}

.app-header .header-body .header-info .header-message:hover .header-message-box {
	visibility: visible
}

.app-header .header-body .header-info .header-message:hover .header-message-drop {
	visibility: visible;
	transform: translateY(0)
}

.app-header .header-body .header-info .header-link {
	width: 92px;
	height: 30px;
	line-height: 30px;
	display: inline-block;
	vertical-align: middle;
	border-radius: 50px;
	text-align: center;
	color: #fff;
	background: linear-gradient(90deg, #27a3ff, #2380fb);
	transition: transform .2s ease
}

.app-header .header-body .header-info .header-link:hover {
	transform: scale(1.05)
}

.app-header .header-body .header-info .header-link-out {
	position: absolute;
	top: 10px;
	right: -100px;
	width: 92px;
	height: 30px;
	line-height: 28px;
	display: inline-block;
	vertical-align: middle;
	border-radius: 50px;
	text-align: center;
	border: 1px solid #333;
	background: transparent;
	transition: transform .2s ease;
	color: #333
}

.app-header .header-body .header-info .header-link-out:hover {
	transform: scale(1.05)
} */
</style>



// WEBPACK FOOTER //
// src/components/header.vue